import React, { Dispatch } from 'react';
import { AutoComplete, Form } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../store/ducks/cidadeOrigem/actions';
import { Props } from './props';
import TextFilter from '../TextFilter';
import mask from 'utils/mask';

const SelectCidade: React.FC<Props> = ({ setProps, label, required }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const cidade = useSelector((state: ApplicationState) => state.CidadeOrigem.data);
  const { Option } = AutoComplete;

  React.useLayoutEffect(() => {
    const controller = new AbortController();
    dispatch(loadRequest());
    return () => {
      controller.abort();
    };
  }, [dispatch]);

  const handleSelect = (value: string, e: any) => {
    setProps(e);
  };

  return (
    <Form.Item
      label={label ? <TextFilter>{label}</TextFilter> : null}
      name="cidadedeorigem"
      rules={[{ required: required ?? false, message: 'Selecione a cidade' }]}
    >
      <AutoComplete
        filterOption={(inputValue, option) =>
          option!.value?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
        }
        onChange={handleSelect}
        data-testid="select"
        placeholder="Selecione a cidade"
      >
        {cidade?.map((item: any) => (
          <Option data-testid="select-option" key={item.codCid} value={mask('cidadeUf', item.nome)}>
            {mask('cidadeUf', item.nome)}
          </Option>
        ))}
      </AutoComplete>
    </Form.Item>
  );
};

export default SelectCidade;
